<template>
    <v-card
        flat
        tile
        :height="cardHeight"
        id="careers"
    >
        <v-parallax
            src="@/assets/components/quality/quality_hero1920x1280.webp"
            style="height: 100%"
            class="hero"
        >
            <v-container fill-height>
                <v-row class="hero-content">
                    <v-col cols="12" class="d-flex flex-column align-center text-center">
                        <v-img
                            src="@/assets/mark_logo.png"
                            contain
                            width="90"
                            alt="Prospira 'S' style logo"
                        ></v-img> 

                        <h3 class="text-h3 mt-3 font-weight-bold black--text">Creating Customer Value &amp; Trust</h3>

                        <h6 class="text-h6 font-weight-bold my-3 black--text">
                            Leadership empowers employee ownership,<br>drives innovation and supports TQM
                        </h6>
                    </v-col>
                </v-row>
            </v-container>
        </v-parallax>
    </v-card>
</template>

<script>
export default {
    name: 'QualityHero',

    computed: {
        border() {
            return this.$vuetify.breakpoint.mdAndDown ? '' : 'hero-text'
        },

        cardHeight() {
            return this.$vuetify.breakpoint.mdAndDown ? '90vh' : '50vh';
        }
    }
}
</script>

<style scoped>
.hero {
    width: 100%;
    position: absolute;
    background-color: #ffffff;
    opacity: 0.9;
}

.hero-content {
    z-index: 999;
}

.hero-text {
    border-left: 3px solid white;
}

.red-gradient {
    background: rgb(168,18,10);
    background: linear-gradient(to right,#a8120a 0,#ee2e24 100%);
}
</style>